export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/constant.js
// module id = 258
// module chunks = 0